import axios from 'axios';
import CONFIG from '../config';

export const getHowContent = () => axios.get(`${CONFIG.API_BASE}/xapi/content/get/how`).then(res => res.data);
export const getHowDetailContent = (slug) => axios.get(`${CONFIG.API_BASE}/xapi/content/get/how/${slug}`).then(res => res.data);
